import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "/";

export type listType = {
  keyword?: number;
  limit?: number;
  page?: number;
};



export type thesis_progress_step = {
  id_thesis_progress_step: number | null;
  thesis_progress_step_name: string;
  seq: number | null;
  thesis_progress_step_percent: number | null;
  thesis_progress_step_status: string;
  status: string;
}
export type my_the_sis_progress_data = {
  thesis_name: string;
  thesis_progress_desc: string;
  thesis_progress_percent: string;
  id_thesis_progress_file: number[];
  clone_thesis_progress_file_id?:number[];
  thesis_progress_step: thesis_progress_step[];
}

export class ThesisProgressApi extends BaseAPI {
  static list(query: any): Promise<any> {
    return this.api.get(`/approve-student-thesis`, {
      params: { ...query },
    });
  }
  static listThesisProgress(query: any, id: any): Promise<any> {
    return this.api.get(`/approve-student-thesis/${id}/thesis-progress`, {
      params: { ...query },
    });
  }
  static myThesisProgress(query: any): Promise<any> {
    return this.api.get(`/my-thesis-progress`, {
      params: { ...query },
    });
  }
  static postMyThesisProgress(body: my_the_sis_progress_data): Promise<any> {
    return this.api.post(`/my-thesis-progress`, body);
  }
  static patchMyThesisProgress(body: any, id: any): Promise<any> {
    return this.api.patch(`/my-thesis-progress/${id}`, body);
  }
  static findByIdThesisProgress(
    id_student: any,
    id_thesis_progress: any
  ): Promise<any> {
    return this.api.get(
      `/approve-student-thesis/${id_student}/thesis-progress/${id_thesis_progress}`
    );
  }
  static findByIdMyThesisProgress(id: any): Promise<any> {
    return this.api.get(`/my-thesis-progress/${id}`);
  }
  static patch(
    body: any,
    id_student: any,
    id_thesis_progress: any
  ): Promise<any> {
    return this.api.patch(
      `/approve-student-thesis/${id_student}/thesis-progress/${id_thesis_progress}`,
      body
    );
  }

  static delete(id: any): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static uploadProgress(body: any): Promise<any> {
    return this.api.post(`/upload-approve-thesis-progress-file`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  static uploadMyProgress(body: any): Promise<AxiosResponse> {
    return this.api.post(`/upload-my-thesis-progress-file`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  static export(query: any): Promise<any> {
    return this.api.get(`/export-approve-student-thesis`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }


  static stepProgress(): Promise<AxiosResponse> {
    return this.api.get(`/progress-step-thesis-list`)
  }
  static deleteList(id_thesis_progress: number): Promise<AxiosResponse> {
    return this.api.delete(`/my-thesis-progress/${id_thesis_progress}`);
  }

  static oldFileThesis(): Promise<AxiosResponse> {
    return this.api.get(`/old-file-thesis`)
  }
}
